export const ItalicIcon = () => {
    return (
        <svg
            width={20}
            height={20}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="fill-black dark:fill-white"
        >
            <path d="M18 0H8.333a1.25 1.25 0 0 0 0 2.5h3.35l-5.713 15H2A1.25 1.25 0 0 0 2 20h9.667a1.25 1.25 0 0 0 0-2.5h-3.02l5.713-15H18A1.25 1.25 0 0 0 18 0Z" />
        </svg>
    );
};
